<template>
  <div id="ClientDomainSetup">
    <v-form ref="ClientDomainSetupForm">
      <v-container>
        <v-layout wrap class="pl-4">
          <v-flex class="xs12">
            <h3 class="mb-3 custom-title">
              Client website configuration
            </h3>
          </v-flex>
          <v-flex xs12 sm6>
            <v-select v-model="clientDomainSettings.financial_worksheet_required"
              label="Is Financial Worksheet Required?" :items="yesOrNoArray" class="pr-4"
              @change="isFormDataChanged = true"></v-select>
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field
              @input="isFormDataChanged = true"
              v-model="clientDomainSettings.privacy_policy_url"
              :rules="rules.url"
              hint="https://www.example.com/privacy-policy"
              persistent-hint
              label="Privacy Policy URL"
              class="pr-4"
            >
            </v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field
              @input="isFormDataChanged = true"
              v-model="clientDomainSettings.terms_and_conditions_url"
              :rules="rules.url"
              hint="https://www.example.com/terms-and-conditions"
              persistent-hint
              label="Terms & Conditions URL"
              class="pr-4"
            >
            </v-text-field>
          </v-flex>
        </v-layout>

        <v-layout class="button-container pr-4 pl-4">
          <v-flex xs12 sm12 md12 v-if="isFormDataChanged" class="pr-0 text-xs-right">
            <div class="d-inline-flex">
              <v-btn class="pf-btn pf-btn-cancel" @click="cancel">
                <v-icon size="16" class="pr-1">cancel</v-icon>
                <div>Cancel</div>
              </v-btn>
              <v-btn class="pf-btn pf-btn-save" @click="save">
                <v-icon size="16" class="pr-1">check_circle</v-icon>
                <div>Save</div>
              </v-btn>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>
<script>

/* global session store config */
import swal from 'sweetalert2';
import { update, validateUrl, getCollection } from '../../helpers/helpers';

// The non-wordpress badge setup page for the agency
export default {
  name: 'ClientDomainSetup',
  data: vm => ({
    isFormDataChanged: false,
    yesOrNoArray: [
      { text: 'Yes', value: true },
      { text: 'No', value: false }
    ],
    clientDomainSettingsBackup: {},
    clientDomainSettings: {
      financial_worksheet_required: true,
      privacy_policy_url: 'https://app.websitepolicies.com/policies/view/v2lusljn',
      terms_and_conditions_url: 'https://app.websitepolicies.com/policies/view/s04ml1o8'
    },
    rules: {
      url: [
        v => v === '' || validateUrl(v) || 'Please enter a valid URL'
      ]
    }
  }),
  computed: {
    Agency: {
      get () {
        return store.state.Agency;
      },
      set (value) {
        store.commit('setAgency', value);
      }
    }
  },
  created () {
    if (this.Agency && this.Agency.client_domain_settings !== undefined) {
      this.clientDomainSettings = JSON.parse(JSON.stringify(this.Agency.client_domain_settings));
    } else {
      // Fetch admin details and use the default settings
      this.fetchAdminSettings();
    }
    this.clientDomainSettingsBackup = JSON.parse(JSON.stringify(this.clientDomainSettings));
  },
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  methods: {
    async fetchAdminSettings () {
      let { error, data } = await getCollection('Agency', true, 0, '', { is_super_admin: true }, 'client_domain_settings');
      if (error) {
        console.log('error', error);
        this.snackbar = {
          show: true,
          color: 'red',
          text: typeof error === 'string' ? error : 'Something went wrong, please try again.'
        };
      } else if (data.length) {
        const admin = data[0];
        if (admin && admin.client_domain_settings !== undefined) {
          this.clientDomainSettings = JSON.parse(JSON.stringify(admin.client_domain_settings));
        }
      }
    },
    // @vuese
    // Used to hide the form buttons and set the agency badge obtions
    cancel () {
      this.isFormDataChanged = false;
      this.clientDomainSettings = JSON.parse(JSON.stringify(this.clientDomainSettingsBackup));
    },
    // @vuese
    // Used to save the form data
    async save () {
      if (this.$refs.ClientDomainSetupForm.validate()) {
        this.isFormDataChanged = false;
        this.Agency.client_domain_settings = {}; // Added since the non used fields were not cleared on changing the field names
        this.Agency.client_domain_settings = this.clientDomainSettings;
        this.Agency.updated_from = 'basic';
        let { error, data, status } = await update('Agency', this.Agency, session.getSession().adminUser ? session.getSession().user.human.agency : 'Me');
        if (error) {
          console.log('error', error);
          this.isFormDataChanged = true;
          this.snackbar = {
            show: true,
            color: 'red',
            text: typeof error === 'string' ? error : 'Something went wrong, please try again.'
          };
        } else {
          this.Agency = data;
          swal.fire({
            type: 'success',
            title: 'Success',
            text: 'Client website configuration updated successfully.',
            showCloseButton: true,
            showConfirmButton: false,
            timer: 2500
          });
        }
      }
    }
  }
};
</script>

<style lang="css" scoped></style>


// WEBPACK FOOTER //
// src/pages/ClientDomains/config.vue